<template>
  <div>
    <component v-if="landingPage" :is="'LandingPage'"></component>
    <div v-else :class="['pt-4 md:pt-0']">
      <div
        class="flex justify-center mb-2 text-center"
        v-if="
          menu['temp_disabled_msg' + '_' + language] &&
          !menu.is_ordering_enabled
        "
      >
        <p class="bg-red-600 fit text-white py-1 px-2 rounded-xl mx-2">
          {{ menu["temp_disabled_msg" + "_" + language] }}
        </p>
      </div>
      <div
        :class="[
          'overflow-auto max-h-screen md:pb-56 rounded-t-xxl md:rounded-t-xxl md:m-12 bg-white md:bg-transparent',
          menuCategories.length > 2 ? 'pb-40' : 'pb-0',
        ]"
        :style="hasKiosk && mainSectionTopRadius "
        v-if="menuCategories.length > 0"
      >
        <div class="mt-4 flex flex-row mx-4 hidden">
          <div :class="['flex w-1/2 lg:w-2/3 justify-begin text-3xl flex-col']">
            <div v-trans:name="selectedMenuCategory"></div>
            <div
              class="text-xs"
              v-trans:description="selectedMenuCategory"
            ></div>
          </div>
          <div
            class="flex w-1/2 lg:w-1/3 justify-end items-center cursor-pointer"
          >
            <Language /><DisplayMode class="ml-2" />
          </div>
        </div>
        <div
          class="flex content-center flex-wrap rounded-t-xxl md:rounded-b-xxl pb-90"
          :style="hasKiosk && mainSectionTopRadius "
        >
          <!-- diffrend category's (homescreen) -->
          <!-- isListDisplayed is second view option -->
          <div
            v-for="(menuCategory, index) in menuCategories"
            v-if="((hasKiosk && !isMobileDevice) ? (currentKioskMode == lang['take_away'][language]) ? menuCategory.is_take_out : (currentKioskMode == lang['dine_in'][language] ? menuCategory.is_dine_in : true) : true)"
            v-bind:key="menuCategory.Id"
            :class="[
              menu.is_square_layout ? '' : 'lastBorderRounded',
              isListDisplayed ? 'w-full bg-white rounded' : 'w-1/2',
              menuCategories.length > 4 ? '' : 'test',
            ]"
            @click="getCategories(menuCategory)"
          >
            <div
              class="flex flex-col px-4 categoryItem"
              :style="backgroundImage || backgroundMainFullImage ? '' : mainSubCategorysBackground"
              v-if="menuCategory.parentCategoryId == 0"
            >
              <div
                :class="[
                  'cursor-pointer flex justify-center h-24 items-center my-2 transition duration-500 pl-8 pr-4',
                  isListDisplayed
                    ? ''
                    : index % 2 == 0
                    ? 'mr-2 flex-col'
                    : 'ml-2 flex-col',
                ]"
              >
                <div
                  :class="[
                    'flex items-center w-full justify-between lg:mx-6',
                    menuCategory.picture_url ? 'justify-end' : 'justify-center',
                    isListDisplayed ? 'flex-row' : 'flex-col',
                  ]"
                >
                  <div class="flex items-center">
                    <div
                      v-if="menuCategory.picture_url"
                      class="flex items-center mr-6"
                    >
                      <div
                        class="h-16 w-24 rounded-lg overflow-hidden flex items-center"
                      >
                        <path
                          d="M242.6 280.3l-103.9 82.2c-5 4-13.1 4-18.2 0l-12.1-9.6c-5-4-5-10.4 0-14.3l82.4-65.5-82.4-65.5c-5-4-5-10.4 0-14.3l12.1-9.6c5-4 13.1-4 18.2 0l103.9 82.2c5 4 5 10.4 0 14.4z"
                          fill="#666666"
                        />
                        <img
                          :src="menuCategory.picture_url"
                          alt
                          class="rounded-lg h-full object-cover"
                        />
                      </div>
                    </div>
                    <!-- title category -->
                    <div
                      :class="[
                        menu.layout == 'frydate' ? 'text-2xl uppercase' : '',
                        'font-semibold',
                        isListDisplayed
                          ? menuCategory.picture_url
                            ? 'w-1/2'
                            : ''
                          : '',
                      ]"
                      :style="makeStyles(titleMain , hasKiosk&&titleFont,hasKiosk&&titleTextTransform)"
                      v-trans:name="menuCategory"
                    ></div>
                  </div>
                  <div
                    class="bg-primary-100 rounded-full w-8 h-8 flex justify-center"
                    :style="btnThirdBackground"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 320 512"
                    >
                      <path
                        d="M242.6 280.3l-103.9 82.2c-5 4-13.1 4-18.2 0l-12.1-9.6c-5-4-5-10.4 0-14.3l82.4-65.5-82.4-65.5c-5-4-5-10.4 0-14.3l12.1-9.6c5-4 13.1-4 18.2 0l103.9 82.2c5 4 5 10.4 0 14.4z"
                        :fill="buttonImgColors"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <p
                v-if="menuCategory['description' + '_' + language]"
                class="text-sm -mt-4 mb-4 w-full ml-8"
              >
                {{ menuCategory["description" + "_" + language] }}
              </p>
              <hr class="h-0.5 bg-gray-200" />
            </div>
            <!-- <div>
              <SwipeCartFromBottom />
            </div> -->
          </div>
        </div>
      </div>
      <div v-if="errorTimer" class="bg-white text-center pt-6">
        <p>Please enter valid Menu Code</p>
        <p
          @click="
            $router.push({
              path: `/`,
            })
          "
          class="text-primary-300 font-bold"
        >
          Click here to try again
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import DisplayMode from "../views/DisplayMode";
import Language from "../views/Language";
import lang from "../lang";
import Vue from "vue";
// import { saveNewSessionId } from "../utils";
import SwipeCartFromBottom from "./SwipeCartFromBottom";
export default {
  data() {
    return {
      lang: lang,
      landingPage: false,
      errorTimer: false,
      comoMemberCode: sessionStorage.getItem('comoMemberCode'),
      isLoyaltyMember: sessionStorage.getItem('isLoyaltyMember')
    };
  },
  name: "Home",
  components: { DisplayMode, Language },
  computed: {
    ...mapGetters([
      "language",
      "infiniteScroll",
      "menuCategories",
      "categoryId",
      "menuSubCategories",
      "selectedMenuCategory",
      "isListDisplayed",
      "menu",
      "menuItems",
      "cartItems",
      "currentKioskMode",
      "isMobileDevice",
      "hasKiosk",
      "desktopMode",
    ]),
    ...mapGetters("Theme", [
      "btnThirdBackground",
      "mainSectionTopRadius",
      "cardSecondaryBackground",
      "mainSubCategorysBackground",
      "titleMain",
      "titleFont",
      "titleTextTransform",
      "buttonImgColors",
      "backgroundImage",
      "backgroundMainFullImage"
    ]),
  },
  created() {
    this.$nextTick(() => {
      // prints the error message on the qr-menu page if there is no menuhash or a false menuhash
      if (!this.menu.menu_hash || this.menu.menu_hash == undefined) {
        setTimeout(() => {
          this.$store.commit('updateIsThemeLoading', false);
          this.errorTimer = true;
        }, 2000);
      }
      sessionStorage.removeItem("orderChunksExists");
      // saveNewSessionId("Home > created:202");
      this.$store.dispatch('CREATE_NEW_SESSION_ID')
    });
  },
  watch: {
    menuCategories(val) {
      if (val && !this.hasKiosk && !this.isMobileDevice) {
        this.getCategories(this.menuCategories[0]);
      }
    }
  },
  mounted() {
    // if (!this.menu.menu_hash || this.menu.menu_hash == undefined) {
    //   setTimeout(() =>{
    //     this.$store.commit('updateIsThemeLoading', false);
    //     this.errorTimer = true;
    //   }, 500);
    // }
    // gets the landingpage (this does not work with vue router, this is a diffrend method to handle routers)
    if (this.$route.path.includes("/L/")) {
      this.$store.commit(
        "updateLandingPageHash",
        this.$route.path.replace("/L/", "")
      );
      this.$store
        .dispatch("GET_LANDING_PAGE")
        .then(() => {
          Vue.component(
            "LandingPage",
            // A dynamic import returns a Promise.
            () => import("./LandingPage")
          );
          this.landingPage = true;
        })
        .catch(() => {});
    }

    /**
     * If Landing page is being accessed then it is not necessary to make
     * the `GET GetTablesOrdering` API.
     */
    // if (!this.$route.path.includes("/L/")) {
    //   /** Update table ID if exists. */
    //   if (this.$route.params.stickerId && this.$route.params.stickerId != 0) {
    //     this.$store.dispatch("Cart/GET_TABLES").then((response) => {
    //       let tableObject = this.$_.findLast(response.data, (item) => {
    //         return item.stickerId == this.$route.params.stickerId;
    //       });
    //       /** If valid StickerId, then update the table ID else keep it 0 (zero) */
    //       if (tableObject) {
    //         this.$store.commit("Cart/updateStickerId", tableObject.stickerId);
    //         // this.$store.commit("updateTableId", parseInt(tableObject.Id));
    //         this.$store.commit("Cart/updateTableId", parseInt(tableObject.Id));
    //       }
    //       else {
    //         //code reset sticker id even if not neccesary 
    //         /* this.$store.commit("Cart/updateTableId", null);
    //         localStorage.setItem("tableId", null);*/
    //         this.$store.commit("Cart/updateTableId", null);
    //         // localStorage.setItem("stickerId", 0); 
    //         this.$store.commit("Cart/updateStickerId", 0);
    //       }
    //     });
    //   } else {
    //     this.$store.commit("Cart/updateTableId", null);
    //     // localStorage.setItem("tableId", null);
    //     this.$store.commit("Cart/updateStickerId", 0);
    //     // localStorage.setItem("stickerId", "0");
    //   }
    // }
    this.$store.commit("updateMenuSubCategories", []);
  },
  methods: {
    // get the categories and the subcategories (if there are any)
    getCategories(item) {
      this.$store.commit(
        "updateSessionId",
        sessionStorage.getItem("sessionId")
      );
      let lastSelectedMenuCategory = this.selectedMenuCategory;
      this.$store.commit("updateSelectedMenuCategory", item);
      this.$store.commit("updateCategoryId", item.Id);
      if (item.hasSubCategories) {
        this.$store.commit("updateSubCategoryId", item.Id);
        this.$store.dispatch("GET_MENU_SUB_CATEGORIES");
        this.$store.commit("updateMenuCategoriesCategories", item);
        this.$router
          .push("/" + this.$route.params.menuHash + "/category/" + item.Id)
          .catch(() => {});
      } else {
        // if(this.infiniteScroll){
        //   if(!Object.keys(this.menu).length&&!this.$store.getters.loadingItems){
        //     this.$store.dispatch("GET_ALL_MENU_ITEMS");
        //   }
        // }else{
        //   this.$store.dispatch("GET_CATEGORY");
        // }

        /**
         * If it is infiniteScroll then all item must be loaded already so no need to call again ,
         * If it is loading that some other component had dispatched this action,
         * If menuItems list is empty or the selected menu is different than the previous menu that items we have
         * then call api and get those data.
         */
        if (!this.$store.getters.loadingItems && !this.infiniteScroll
              && (!this.menuItems.length || lastSelectedMenuCategory.Id != item.Id)) {
              this.$store.dispatch("GET_CORRECT_MENU_ITEMS");
          }
        this.$router
          .push("/" + this.$route.params.menuHash + "/sub/category/" + item.Id)
          .catch(() => {});
      }
    },
  },
  updated() {
    if (this.menu.menu_hash) {
      this.errorTimer = false;
    }
  },
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.lastBorderRounded:last-of-type hr {
  display: none;
}

@media only screen and (min-width: 765px) {
  .lastBorderRounded:last-of-type .categoryItem {
    border-bottom-left-radius: 2rem;
    border-bottom-right-radius: 2rem;
  }
  .lastBorderRounded:last-of-type {
    border-bottom-left-radius: 3rem;
    border-bottom-right-radius: 3rem;
  }
}

.test:last-of-type {
  border-bottom-left-radius: 3rem;
  border-bottom-right-radius: 3rem;
  border-bottom-left-radius: 2rem;
  border-bottom-right-radius: 2rem;
}

.fit {
  width: fit-content;
}
</style>
